<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header :status="currentStatus" />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="employeeData"
      :status="currentStatus"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import Header from 'components/invoiceExtendDueDate/Header'
import Form from 'components/invoiceExtendDueDate/Form'
import Footer from 'components/invoiceExtendDueDate/Footer'

export default {
  name: 'InvoiceExtendDueDate',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      submitForm: false,
      employeeData: null,
      currentStatus: null
    }
  },
  methods: {
    redirectToInvoiceList () {
      if (!this.routeParams.invoiceId || !this.routeParams.dueDateOpt) {
        this.$router.push({ name: 'Financial' })
      }
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    }
  },
  beforeMount () {
    this.redirectToInvoiceList()
  },
  mounted () {
    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
